var map = {
	"./heatmap-thumbnail-BRCA.png": 899,
	"./heatmap-thumbnail-COAD.png": 263,
	"./heatmap-thumbnail-GBM.png": 4845,
	"./heatmap-thumbnail-HGSC.png": 6994,
	"./heatmap-thumbnail-HNSCC.png": 2924,
	"./heatmap-thumbnail-LSCC.png": 5683,
	"./heatmap-thumbnail-LUAD.png": 1472,
	"./heatmap-thumbnail-PDAC.png": 5861,
	"./heatmap-thumbnail-UCEC.png": 9591,
	"./heatmap-thumbnail-ccRCC.png": 6945,
	"./heatmap-thumbnail-pancan.png": 3921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6062;